import React from 'react';
import { useI18n } from '../../../../../../data/hooks/i18nHooks';
import { useParticipantsFilterEnabled } from '../../../../../../data/hooks/participant/useParticipantsFilterEnabled';
import StartNetworkingStep from '../../../StartNetworkingStep/StartNetworkingStep';

function StepFilterParticipants(props) {
    const {eventId} = props,
        i18n = useI18n(),
        participantsFilterEnabled = useParticipantsFilterEnabled(eventId);

    return (
        <StartNetworkingStep href={['/events', eventId, 'participants', 'filter'].join('/')+'#categories-filter'} visible={participantsFilterEnabled}>
            {i18n['start.filter_contacts']}
        </StartNetworkingStep>
    );
}

export default StepFilterParticipants;
